import { Box, Typography } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import React from "react";
import { FormattedMessage } from "react-intl";
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { SpecCreator } from "./SpecCreator";
import { useDialogProps } from "legacy-components/dialog/Dialog";
import { OPENAPI_LINTING_SKILL_URL } from "constants/URL";

interface SpecUploaderProps {
  apiId: string;
  version: string;
  refreshDeployments: ()=>void;
}

export const SpecUploader: React.FC<SpecUploaderProps> = React.memo(({ apiId, version, refreshDeployments}) => {
    const { open, toggle } = useDialogProps();

    const handler = () => {
        toggle();
    };

    return (
    <Box width="100%">
      <Alert
        severity="info"
        style={{
          marginBottom: "16px",
          border: "1px solid #0063a3",
          color: "#0063a3",
          backgroundColor: "#dcedf9",
        }}
      >
        <Typography variant="subtitle1" style={{ fontWeight: 700, color: "#0063a3" }}>
          Want to pass OpenAPI Specification on your first upload?
        </Typography>
        <Typography variant="body2" style={{ color: "#0063a3", marginTop: 4 }}>
          Validate your OpenAPI specifications locally while you design. Install the Trimble OpenAPI Standards
          Linting Agentic Skill directly into your code editor to surface errors and warnings live.
        </Typography>
        <Typography variant="body2" style={{ marginTop: 4 }}>
          <a
            href={OPENAPI_LINTING_SKILL_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#0b4f71", textDecoration: "underline" }}
          >
            Learn how to setup the local skill
          </a>
        </Typography>
      </Alert>
      <Box style={{ paddingLeft: "32px", paddingBottom: "20px" }}>
        <Box
          style={{
            borderStyle: "dashed",
            height: "150px",
            width: "450px",
            marginBottom: "20px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            borderColor: "#b7b9c3",
          }}
          onClick={handler}
        >
          <CloudUploadIcon style={{ color: "#b7b9c3" }} />
          <FormattedMessage defaultMessage={"Upload Api Specification"} />
        </Box>
        <SpecCreator
          apiId={apiId}
          version={version}
          onOpen={open}
          onClose={toggle}
          refreshDeployments={refreshDeployments}
        />
      </Box>
    </Box>
    );
})
